














































































// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import { AloActivity, getDefaultAloActivity } from '@/models/alo/AloActivity'
import { VuetifyConfirmObject } from '@/plugins/confirm/types'
import {DashboardAdmin} from '@/router/pages'
import apiActivity from '@/api/activity'
import { directPayloadQuery } from '@/utils/api'

@Component({
  name: 'GestionActivity'  
})
export default class GestionActivity extends Vue {
  private loading = false
  private showError = false  
  private showNew = false
  private newActivity = getDefaultAloActivity()
  private defaultHeaderHeight = 90
  mounted() {
    this.defaultHeaderHeight = 5
  }
  get tableauHeight(){
    //@ts-ignore
    return this.$store.myGetters.contentHeight - ((this.$refs?.header?.clientHeight+this.defaultHeaderHeight)??this.defaultHeaderHeight)
  }

  private headers = [
    { text: '', value: 'acyOrdre', width:70 },       
    { text: 'ID', value: 'id', width:70 },    
    { text: 'Enfant', value: 'acyEnfant', width:100 },
    { text: 'Activité', value: 'libelle' },
    { text: '', value:'actions', width:30, sortable:false,filterable:false}
  ]

  private get activityList() {
    return this.$store.myGetters.activityList
  }

  private set activityList(values) {
    this.$store.myActions.ADM_ACTIVITY_SET_LIST(values.map(it => it.id))
  }

  private get search(){
    return this.$store.myGetters.searchActivity
  }
  private set search(value){
    this.$store.myActions.UI_SET_SEARCH_ACTIVITY(value)
  }

  private get sortDesc(){
    return this.$store.myGetters.sortActivityDesc
  }
  private set sortDesc(value){
    this.$store.myActions.UI_SET_SORT_ACTIVITY_DESC(value)
  }

  private get sortBy(){
    return this.$store.myGetters.sortActivityBy
  }
  private set sortBy(value){
    this.$store.myActions.UI_SET_SORT_ACTIVITY_BY(value)
  }

    
  created() {
    this.loading = true
    this.$store.myActions.ADM_ACTIVITY_ENSURE().finally(() => {
      this.loading = false
    })
  }


  openDetail(item: any) {
    this.$router.push({name:'ModifyActivity',params:{activityId:item.id}})    
  }

  deleteActivity(activity:AloActivity) {
     if(activity.id != 0) {      
       this.$confirm(`Voulez vous vraiment supprimer la activity "${activity.libelle}" ?`,{title: "Attention"} as VuetifyConfirmObject).then((answer) => {
        if (answer) {          
          this.$store.myActions.ADM_ACTIVITY_DELETE_REQUEST(activity.id)
        } 
      })          
    } 
  }

  addActivity(){
    this.showNew = true  
    this.newActivity = getDefaultAloActivity()
  }

  save(){
    this.$store.myActions.ADM_ACTIVITY_SAVE_REQUEST(this.newActivity).then((activity)=>{
      this.showNew = false
      this.openDetail(activity)
    })    
  }

  onOrderActivityChange() {        
    directPayloadQuery(apiActivity.sortActivity,this.activityList.map(it => it.id).join(','))
    .then(activities => {                  
      this.$store.myActions.UI_ADD_SNACK_MESSAGE("Ordre des activités sauvegardé")     
    })    
  }

  get arianeItems() {
    return  [
        DashboardAdmin,
        {
          text: 'Activités',
          disabled: true,  
          to: {name:'AdminActivity'},        
          exact:true
        }
      ]      
  } 
 
}
